<div [formGroup]="form">

  <!--<label class="control control--checkbox">
    <input type="checkbox" class="" id="bulk-sign-all" name="bulk-sign-all" [checked]="allDocumentSelected" (change)="checkUncheckAll($event)">
    <span class="control__indicator"></span>
    <label for="bulk-sign-all">Select all</label>
  </label>-->

  <label class="control control--checkbox" *ngFor="let opt of field.Answers" [ngClass]="{'control--vertical' : field.QuestionRender == 'Vertical' }">
    <input (change)="onCheckboxChange($event, opt)" [checked]="opt.checked" type="checkbox" [id]="opt.uniquename" [value]="opt.FormAnswerID" [disabled]="field.controlDisabled" />
    <span class="control__indicator"
          [ngClass]="{'input-validation-error': isTouched && isInValid }"></span>
    <span>{{opt.Answer}}</span>
  </label>
</div>
